import { Component, Input } from "@angular/core";

@Component({
	selector: "app-data-tile",
	templateUrl: "./data-tile.component.html",
	styleUrls: ["./data-tile.component.scss"],
})
export class DataTileComponent {
	@Input() value: string;
	@Input() valueColor: string;
	@Input() title: string;
	@Input() titleColor: string;
	@Input() subTitle: string;
	@Input() subTitleColor: string;
	@Input() tileColor: string;
	@Input() indicatorText: string;
	@Input() indicatorIcon: string;
	@Input() indicatorTextColor: string;
	@Input() indicatorIconColor: string;
	@Input() isLoading: boolean;

	constructor() {}
}
